enum CartType {
	Product = 0,
	QuickOrder = 1,
	CustomTrainingRequest = 2,
}

export default CartType;
